// Store subscriptions — event-driven data loading
// Connects auth state changes to dependent data loading
// without coupling stores directly or using useEffect in components.
import { useAuthStore } from '../stores/authStore';
import { useWorkflowsStore } from '../stores/workflowsStore';
import { useExcelFilesStore } from '../stores/excelFilesStore';

let previousUserId: string | null = null;
let initialized = false;
// H-F005: Referencia a la suscripcion para poder limpiarla en HMR
let unsubscribe: (() => void) | null = null;

/**
 * H-F029: Inicializa las subscripciones entre stores de forma explícita.
 * Llamar desde main.tsx para evitar side effects al importar el módulo.
 * Es idempotente: si se llama más de una vez, no registra listeners duplicados.
 */
export function initializeSubscriptions(): void {
  if (initialized) return;
  initialized = true;

  unsubscribe = useAuthStore.subscribe((state: { user: { uid: string } | null }) => {
    const currentUserId = state.user?.uid ?? null;

    if (currentUserId && currentUserId !== previousUserId) {
      previousUserId = currentUserId;
      void useWorkflowsStore.getState().fetchWorkflows(currentUserId);
    } else if (!currentUserId && previousUserId) {
      // Usuario deslogueado: limpiar datos de la sesión anterior
      previousUserId = null;
      useWorkflowsStore.setState({
        workflows: [],
        currentWorkflow: null,
        importDraft: null,
        loading: false,
        error: null,
      });
      useExcelFilesStore.getState().clearFiles();
    }
  });
}

/**
 * H-F005: Limpia las suscripciones y resetea el estado.
 * Necesario para HMR: sin esto, al recargar en desarrollo se registran
 * listeners duplicados porque las variables de modulo persisten entre reloads.
 */
export function disposeSubscriptions(): void {
  if (unsubscribe) {
    unsubscribe();
    unsubscribe = null;
  }
  previousUserId = null;
  initialized = false;
}

// H-F005: Cleanup automatico en HMR (Vite hot module replacement)
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    disposeSubscriptions();
  });
}
